export const DEFAULT_DURATION = 5;
